import { ROUTES } from "../../../components/shared/constant";
import { NAV_IDS, type NavId } from "./sidebarConfig";

export function getNavRoute(navId: NavId): string {
  return NAV_TO_ROUTE_BASE[navId];
}

const NAV_TO_ROUTE_BASE: Record<NavId, string> = {
  [NAV_IDS.DASHBOARD]: ROUTES.HOME,
  [NAV_IDS.CONVERSATIONS]: ROUTES.INBOX,
  [NAV_IDS.INBOX]: ROUTES.INBOX,
  [NAV_IDS.CALL_LOGS]: ROUTES.CALL_LOGS,
  [NAV_IDS.TRAINING]: ROUTES.TRAINING,
  [NAV_IDS.AUDIENCE]: ROUTES.LEADS,
  [NAV_IDS.LEADS]: ROUTES.LEADS,
  [NAV_IDS.TOUR_AVAILABILITY]: ROUTES.TOUR_AVAILABILITY,
  [NAV_IDS.SCHEDULED_TOURS]: ROUTES.SCHEDULED_TOURS,
  [NAV_IDS.SMS_ALERT_SETTINGS]: ROUTES.SMS_ALERT_SETTINGS,
  [NAV_IDS.CAMPAIGNS_HUB]: ROUTES.AD_CAMPAIGNS,
  [NAV_IDS.CAMPAIGNS]: ROUTES.AD_CAMPAIGNS,
  [NAV_IDS.DRIP_CAMPAIGNS]: ROUTES.DRIP_CAMPAIGNS,
  [NAV_IDS.AUTO_TRIGGERS]: ROUTES.AUTO_TRIGGERS,
  [NAV_IDS.LANDING_PAGES]: ROUTES.LANDING_PAGES,
  [NAV_IDS.FORMS]: ROUTES.FORMS,
  [NAV_IDS.AB_TESTS]: ROUTES.AB_TESTS,
  [NAV_IDS.LEAD_MAGNETS]: ROUTES.LEAD_MAGNETS,
  [NAV_IDS.CONTENT_HUB]: ROUTES.CONTENT_HUB,
  [NAV_IDS.VIDEOS]: ROUTES.VIDEOS,
  [NAV_IDS.FLOOR_PLANS]: ROUTES.FLOOR_PLANS,
  [NAV_IDS.TESTIMONIALS]: ROUTES.TESTIMONIALS,
  [NAV_IDS.FAQ]: ROUTES.FAQ,
  [NAV_IDS.STAFF_PROFILES]: ROUTES.STAFF_PROFILES,
  [NAV_IDS.ALERT_BANNERS]: ROUTES.ALERT_BANNERS,
  [NAV_IDS.DECISION_SUPPORT]: ROUTES.ASSESSMENTS,
  [NAV_IDS.ASSESSMENTS]: ROUTES.ASSESSMENTS,
  [NAV_IDS.SURVEYS]: ROUTES.SURVEYS,
  [NAV_IDS.SURVEY_TEMPLATES]: ROUTES.SURVEY_TEMPLATES,
  [NAV_IDS.SALES_AGENT]: ROUTES.ASA,
  [NAV_IDS.ASA_LIST]: ROUTES.ASA,
  [NAV_IDS.MODAL_CONFIGS]: ROUTES.MODAL_CONFIGS,
  [NAV_IDS.WIDGET_PLACEMENTS]: ROUTES.WIDGET_PLACEMENTS,
  [NAV_IDS.EMBED_SCRIPT]: ROUTES.EMBED_SCRIPT,
  [NAV_IDS.INQUIRY_TYPES]: ROUTES.INQUIRY_TYPES,
  [NAV_IDS.INSIGHTS]: ROUTES.ANALYTICS,
  [NAV_IDS.ANALYTICS]: ROUTES.ANALYTICS,
  [NAV_IDS.CAMPAIGN_ATTRIBUTION]: ROUTES.CAMPAIGN_ATTRIBUTION,
  [NAV_IDS.UTM_ANALYTICS]: ROUTES.UTM_ANALYTICS,
  [NAV_IDS.CALL_ANALYTICS]: ROUTES.CALL_ANALYTICS,
  [NAV_IDS.ADVISOR_REPORTS]: ROUTES.ADVISOR_REPORTS,
  [NAV_IDS.MODAL_ANALYTICS]: ROUTES.MODAL_ANALYTICS,
  [NAV_IDS.SETTINGS]: ROUTES.GENERAL_SETTINGS,
  [NAV_IDS.GENERAL]: ROUTES.GENERAL_SETTINGS,
  [NAV_IDS.USERS]: ROUTES.USERS,
  [NAV_IDS.USER_SETUP]: ROUTES.USER_SETUP,
  [NAV_IDS.ROLES]: ROUTES.ROLES,
  [NAV_IDS.LOCATIONS]: ROUTES.LOCATIONS,
  [NAV_IDS.OPERATORS]: ROUTES.OPERATORS,
  [NAV_IDS.OWNERS]: ROUTES.OWNERS,
  [NAV_IDS.CHANNELS]: ROUTES.CHANNELS,
  [NAV_IDS.CALL_MANAGEMENT]: ROUTES.CALL_MANAGEMENT,
  [NAV_IDS.LOGS]: ROUTES.LOGS,
  [NAV_IDS.PLATFORM]: ROUTES.PLATFORM,
  [NAV_IDS.INSTANCES]: ROUTES.VIEWINSTANCES,
  [NAV_IDS.TENANTS]: ROUTES.TENANTSETIINGS,
  [NAV_IDS.INTEGRATIONS]: ROUTES.CRM_INTEGRATIONS,
  [NAV_IDS.CRM]: ROUTES.CRM_INTEGRATIONS,
  [NAV_IDS.NOTIFICATION_PREFERENCES]: ROUTES.NOTIFICATION_PREFERENCES,
  [NAV_IDS.CONFIGURATIONS]: ROUTES.CONFIGURATIONS,
  [NAV_IDS.CLOSE_REASONS]: ROUTES.SETTINGS_CLOSE_REASONS,
  [NAV_IDS.STAGES]: ROUTES.SETTINGS_STAGES,
  [NAV_IDS.SETTINGS_SETUP]: ROUTES.SETTINGS_SETUP,
  [NAV_IDS.CRM_OVERVIEW]: ROUTES.CRM_OVERVIEW,
  [NAV_IDS.CRM_DAY_PLANNER]: ROUTES.CRM_DAY_PLANNER,
  [NAV_IDS.CRM_PERSONS]: ROUTES.CRM_PERSONS,
  [NAV_IDS.CRM_RESIDENTS]: ROUTES.CRM_RESIDENTS,
  // The Referrers GROUP parent. It shares the child's route deliberately:
  // the route is what the manifest declares for the group and what the icon
  // registry is keyed by. The parent is excluded from the route→id reverse
  // map below so the CHILD keeps ownership of the route.
  [NAV_IDS.CRM_REFERRERS_HUB]: ROUTES.CRM_REFERRER_PERSONS,
  [NAV_IDS.CRM_OCCUPANCY_HUB]: ROUTES.CRM_OCCUPANCY,
  // REF-9b-1 — the sidebar Referrers nav now lands on the person-first list.
  // REF-10 teardown — the "Referrers" nav is the person-first list.
  [NAV_IDS.CRM_REFERRERS]: ROUTES.CRM_REFERRER_PERSONS,
  [NAV_IDS.CRM_ORGANIZATIONS]: ROUTES.CRM_ORGANIZATIONS,
  [NAV_IDS.CRM_ADMISSIONS]: ROUTES.CRM_ADMISSIONS,
  [NAV_IDS.CRM_OCCUPANCY]: ROUTES.CRM_OCCUPANCY,
  [NAV_IDS.CRM_YARDI_RESOLUTION]: ROUTES.CRM_YARDI_RESOLUTION,
  [NAV_IDS.CRM_REPORTS]: ROUTES.CRM_REPORTS,
  [NAV_IDS.CRM_EVENTS]: ROUTES.CRM_EVENTS,
  [NAV_IDS.CRM_HEALTH]: ROUTES.CRM_HEALTH,
  [NAV_IDS.CRM_SKYAGENT]: ROUTES.CRM_SKYAGENT,
  [NAV_IDS.CRM_SKYBRAIN]: ROUTES.CRM_SKYBRAIN,
  // Playbooks. All four points of the nav wiring are in place — this map, the nav
  // id, the icon in packNav.ts, and the pack manifest line in
  // `lib/packs/senior_living.ts`. Doing three of the four ships a page nobody can
  // reach, which is why `packNavContract.nodb.test.ts` exists; it happened to
  // skyAgent once already.
  //
  // The manifest line gates on `crm_agent_skills`, so `/packs/installed` OMITS the
  // item until an admin turns Team playbooks on under Settings → AI Governance.
  // That is the fail-closed posture working, not a missing door.
  [NAV_IDS.CRM_AGENT_SKILLS]: ROUTES.CRM_AGENT_SKILLS,
  [NAV_IDS.CRM_AGENT_DRAFTS]: ROUTES.CRM_AGENT_DRAFTS,
  [NAV_IDS.CRM_MCP_CONNECTORS]: ROUTES.CRM_MCP_CONNECTORS,
  [NAV_IDS.CRM_MESSENGER]: ROUTES.CRM_MESSENGER,
  [NAV_IDS.CRM_SETUP]: ROUTES.CRM_SETUP,
  [NAV_IDS.CRM_LEAD_SOURCES]: ROUTES.CRM_LEAD_SOURCES,
  [NAV_IDS.CRM_MESSAGE_TEMPLATES]: ROUTES.CRM_MESSAGE_TEMPLATES,
  [NAV_IDS.CRM_COMMUNICATION_TEMPLATES]: ROUTES.CRM_COMMUNICATION_TEMPLATES,
  [NAV_IDS.CRM_GOALS]: ROUTES.CRM_GOALS,
  [NAV_IDS.CRM_CLINICAL_SYNC]: ROUTES.CRM_CLINICAL_SYNC,
  [NAV_IDS.HELP_SUPPORT]: ROUTES.HELPPLUSSUPPORT,
};

/**
 * HUB (category) nav ids, keyed by the route their manifest item declares.
 *
 * A hub owns no page: it is the collapsible parent of the items below it, and
 * SkyNavDrawer never fires onSelect for a category. It exists here because a
 * parent may share its route with a child — "Referrers" is both the group and
 * its person-first list — and the reverse route→id map can only answer with
 * ONE id. The child must keep the route (its id is what active-state,
 * getNavRoute and every existing deep link resolve to), so packNav.ts asks
 * this map for a PARENT's id and getNavIdForRoute for a child's.
 */
const HUB_ROUTE_TO_NAV_ID: Record<string, NavId> = {
  [ROUTES.CRM_REFERRER_PERSONS]: NAV_IDS.CRM_REFERRERS_HUB,
  [ROUTES.CRM_OCCUPANCY]: NAV_IDS.CRM_OCCUPANCY_HUB,
};

const HUB_NAV_IDS: NavId[] = Object.values(HUB_ROUTE_TO_NAV_ID);

/**
 * Reverse lookup: route → nav id. Used by packNav.ts to resolve each
 * pack-manifest sidebar route (the wire contract is routes, not nav ids)
 * to its client nav id for selection/active-state and navigation.
 *
 * NAV_TO_ROUTE_BASE has a few alias nav ids sharing one route (e.g.
 * INTEGRATIONS and CRM → CRM_INTEGRATIONS); for those the LAST entry
 * wins. All /crm/* routes served by pack manifests today are 1:1, so
 * the ambiguity is confined to routes packs do not declare.
 *
 * Hub ids are FILTERED OUT rather than relying on declaration order: a hub
 * shares its child's route, and if the hub won the reverse lookup every
 * child would resolve to the non-navigable parent id.
 */
const ROUTE_TO_NAV_ID: Record<string, NavId> = Object.fromEntries(
  Object.entries(NAV_TO_ROUTE_BASE)
    .filter(([navId]) => !HUB_NAV_IDS.includes(navId as NavId))
    .map(([navId, route]) => [route, navId as NavId]),
);

export function getNavIdForRoute(route: string): NavId | undefined {
  return ROUTE_TO_NAV_ID[route];
}

/** The hub (category) nav id for a nested manifest item's route, if any. */
export function getHubNavIdForRoute(route: string): NavId | undefined {
  return HUB_ROUTE_TO_NAV_ID[route];
}

const ROUTE_PATTERNS: Record<NavId, string[]> = {
  [NAV_IDS.DASHBOARD]: [ROUTES.HOME, ROUTES.DASHBOARD],
  [NAV_IDS.CONVERSATIONS]: [],
  [NAV_IDS.INBOX]: [ROUTES.INBOX],
  [NAV_IDS.CALL_LOGS]: [ROUTES.CALL_LOGS],
  [NAV_IDS.TRAINING]: [ROUTES.TRAINING],
  [NAV_IDS.AUDIENCE]: [],
  [NAV_IDS.LEADS]: [ROUTES.LEADS, ROUTES.LEAD_DETAIL],
  [NAV_IDS.TOUR_AVAILABILITY]: [ROUTES.TOUR_AVAILABILITY],
  [NAV_IDS.SCHEDULED_TOURS]: [ROUTES.SCHEDULED_TOURS],
  [NAV_IDS.SMS_ALERT_SETTINGS]: [ROUTES.SMS_ALERT_SETTINGS],
  [NAV_IDS.CAMPAIGNS_HUB]: [],
  [NAV_IDS.CAMPAIGNS]: [ROUTES.AD_CAMPAIGNS, ROUTES.AD_CAMPAIGN_DETAIL],
  [NAV_IDS.DRIP_CAMPAIGNS]: [
    ROUTES.DRIP_CAMPAIGNS,
    ROUTES.DRIP_CAMPAIGN_DETAIL,
    ROUTES.DRIP_CAMPAIGN_EDITOR,
  ],
  [NAV_IDS.AUTO_TRIGGERS]: [ROUTES.AUTO_TRIGGERS],
  [NAV_IDS.LANDING_PAGES]: [ROUTES.LANDING_PAGES, ROUTES.LANDING_PAGE_BUILDER],
  [NAV_IDS.FORMS]: [ROUTES.FORMS, ROUTES.FORM_BUILDER],
  [NAV_IDS.AB_TESTS]: [ROUTES.AB_TESTS],
  [NAV_IDS.LEAD_MAGNETS]: [ROUTES.LEAD_MAGNETS],
  [NAV_IDS.CONTENT_HUB]: [ROUTES.CONTENT_HUB],
  [NAV_IDS.VIDEOS]: [],
  [NAV_IDS.FLOOR_PLANS]: [ROUTES.FLOOR_PLANS],
  [NAV_IDS.TESTIMONIALS]: [ROUTES.TESTIMONIALS],
  [NAV_IDS.FAQ]: [],
  [NAV_IDS.STAFF_PROFILES]: [ROUTES.STAFF_PROFILES],
  [NAV_IDS.ALERT_BANNERS]: [],
  [NAV_IDS.DECISION_SUPPORT]: [],
  [NAV_IDS.ASSESSMENTS]: [ROUTES.ASSESSMENTS, ROUTES.ASSESSMENT_BUILDER],
  [NAV_IDS.SURVEYS]: [
    ROUTES.SURVEYS,
    ROUTES.SURVEY_CREATE,
    ROUTES.SURVEY_DETAIL,
    ROUTES.SURVEY_EDIT,
    ROUTES.SURVEY_PREVIEW,
    ROUTES.SURVEY_RESULTS,
    ROUTES.SURVEY_RESULTS_DETAIL,
    ROUTES.SURVEY_REQUESTS,
  ],
  [NAV_IDS.SURVEY_TEMPLATES]: [ROUTES.SURVEY_TEMPLATES],
  [NAV_IDS.SALES_AGENT]: [],
  // ⚠️ ALERT_BANNERS stays here ON PURPOSE: this table is ALSO the RouteGuard
  // permission input (getRequiredNavId), and /alert-banners has always been
  // gated on ASA_LIST visibility. The sidebar HIGHLIGHT for it is decoupled in
  // HIGHLIGHT_ONLY_ROUTES below — moving the route to NAV_IDS.ALERT_BANNERS here
  // would silently change who may open the page.
  [NAV_IDS.ASA_LIST]: [
    ROUTES.ASA,
    ROUTES.ASA_DETAIL,
    ROUTES.ALERT_BANNERS,
    ROUTES.VIDEOS,
    ROUTES.FAQ,
  ],
  [NAV_IDS.MODAL_CONFIGS]: [ROUTES.MODAL_CONFIGS],
  [NAV_IDS.WIDGET_PLACEMENTS]: [ROUTES.WIDGET_PLACEMENTS],
  [NAV_IDS.EMBED_SCRIPT]: [ROUTES.EMBED_SCRIPT],
  [NAV_IDS.INQUIRY_TYPES]: [ROUTES.INQUIRY_TYPES],
  [NAV_IDS.INSIGHTS]: [],
  [NAV_IDS.ANALYTICS]: [ROUTES.ANALYTICS],
  [NAV_IDS.CAMPAIGN_ATTRIBUTION]: [ROUTES.CAMPAIGN_ATTRIBUTION],
  [NAV_IDS.UTM_ANALYTICS]: [ROUTES.UTM_ANALYTICS],
  [NAV_IDS.CALL_ANALYTICS]: [ROUTES.CALL_ANALYTICS],
  [NAV_IDS.ADVISOR_REPORTS]: [ROUTES.ADVISOR_REPORTS, ROUTES.ADVISOR_REPORT_DETAIL],
  [NAV_IDS.MODAL_ANALYTICS]: [ROUTES.MODAL_ANALYTICS],
  [NAV_IDS.SETTINGS]: [],
  [NAV_IDS.GENERAL]: [ROUTES.GENERAL_SETTINGS],
  [NAV_IDS.USERS]: [ROUTES.USERS],
  // User Setup merged into Users. /user-setup must be UNGUARDED so
  // UserSetupRedirect can run (→ /users). An empty pattern list makes
  // getRequiredNavId return null for /user-setup (RouteGuard lets it pass).
  [NAV_IDS.USER_SETUP]: [],
  [NAV_IDS.ROLES]: [ROUTES.ROLES],
  [NAV_IDS.LOCATIONS]: [ROUTES.LOCATIONS, ROUTES.LOCATION_DETAIL],
  [NAV_IDS.OPERATORS]: [ROUTES.OPERATORS, ROUTES.OPERATOR_DETAIL],
  [NAV_IDS.OWNERS]: [ROUTES.OWNERS],
  [NAV_IDS.CHANNELS]: [ROUTES.CHANNELS],
  [NAV_IDS.CALL_MANAGEMENT]: [ROUTES.CALL_MANAGEMENT],
  [NAV_IDS.LOGS]: [ROUTES.LOGS],
  [NAV_IDS.PLATFORM]: [ROUTES.PLATFORM],
  [NAV_IDS.INSTANCES]: [
    ROUTES.VIEWINSTANCES,
    ROUTES.VIEWINSTANCEDETAILS,
    ROUTES.VIEWINSTANCEHISTORY,
    ROUTES.VIEWINSTANCEBACKUP,
  ],
  [NAV_IDS.TENANTS]: [ROUTES.TENANTSETIINGS, ROUTES.CREATETENANT],
  [NAV_IDS.INTEGRATIONS]: [ROUTES.CRM_INTEGRATIONS],
  [NAV_IDS.CRM]: [ROUTES.CRM_INTEGRATIONS],
  [NAV_IDS.NOTIFICATION_PREFERENCES]: [ROUTES.NOTIFICATION_PREFERENCES],
  [NAV_IDS.CONFIGURATIONS]: [ROUTES.CONFIGURATIONS],
  // PLC W7 Inc-3 — /settings/competitors rides the CLOSE_REASONS nav id (it is
  // the close-reason catalog's companion list), so RouteGuard admits it exactly
  // where it admits /settings/close-reasons — without a second nav item. NOT a
  // pack-feature or permission check: RouteGuard reads the hardcoded builder,
  // and PROTECTED_NAV_GATES applies only in buildNavSectionsFromConfig. The page
  // refuses without manageSettings and the server enforces both gates.
  [NAV_IDS.CLOSE_REASONS]: [ROUTES.SETTINGS_CLOSE_REASONS, ROUTES.SETTINGS_COMPETITORS],
  [NAV_IDS.STAGES]: [ROUTES.SETTINGS_STAGES],
  // vertical-lead-profile — /settings/lead-profile rides the SETUP nav id (it is
  // reached only from a Setup tile), so RouteGuard admits it where it admits the
  // hub. NOT the access decision: the page requires isPlatformAdmin and the
  // server requireSkypointAdmin.
  [NAV_IDS.SETTINGS_SETUP]: [ROUTES.SETTINGS_SETUP, ROUTES.SETTINGS_LEAD_PROFILE],
  // /crm/* — patterns drive sidebar active-state (getSelectedNavItem).
  // getRequiredNavId early-returns null for /crm/* so RBAC RouteGuard does
  // NOT gate these (PackRouteGuard does).
  [NAV_IDS.CRM_OVERVIEW]: [ROUTES.CRM_OVERVIEW],
  // CRM_LANDING stays mapped to Day Planner for sidebar active-state
  // when a counselor lands via redirect; manager landing on Overview
  // independently activates CRM_OVERVIEW via its own pattern above.
  [NAV_IDS.CRM_DAY_PLANNER]: [ROUTES.CRM_DAY_PLANNER, ROUTES.CRM_LANDING],
  [NAV_IDS.CRM_PERSONS]: [ROUTES.CRM_PERSONS],
  [NAV_IDS.CRM_RESIDENTS]: [ROUTES.CRM_RESIDENTS],
  // The group parent claims NO route of its own (the CAMPAIGNS_HUB idiom) —
  // a child is what gets selected, and the drawer expands its parent from
  // that. If the hub claimed the referrer-persons pattern it would tie with
  // the child on the exact-match pass and could win it.
  [NAV_IDS.CRM_REFERRERS_HUB]: [],
  [NAV_IDS.CRM_OCCUPANCY_HUB]: [],
  [NAV_IDS.CRM_YARDI_RESOLUTION]: [ROUTES.CRM_YARDI_RESOLUTION],
  // REF-10 teardown — the Referrers nav is the person-first surface only (the org
  // referrer routes are retired).
  [NAV_IDS.CRM_REFERRERS]: [ROUTES.CRM_REFERRER_PERSONS, ROUTES.CRM_REFERRER_PERSON_DETAIL],
  [NAV_IDS.CRM_ORGANIZATIONS]: [ROUTES.CRM_ORGANIZATIONS, ROUTES.CRM_ORGANIZATION_DETAIL],
  // BH admissions board (/crm/admissions) — instance-wide, no sub-routes yet.
  [NAV_IDS.CRM_ADMISSIONS]: [ROUTES.CRM_ADMISSIONS],
  // CRM_OCCUPANCY_BOARD / _UNITS listed so the board (/crm/occupancy/board)
  // and units (/crm/occupancy/units) sub-tabs exact-match Occupancy in the
  // first pass; otherwise the prefix pass lets CRM_LANDING ("/crm") claim
  // them before Occupancy is reached.
  [NAV_IDS.CRM_OCCUPANCY]: [
    ROUTES.CRM_OCCUPANCY,
    ROUTES.CRM_OCCUPANCY_BOARD,
    ROUTES.CRM_OCCUPANCY_UNITS,
    ROUTES.CRM_OCCUPANCY_TRANSITIONS,
    ROUTES.CRM_OCCUPANCY_REPORT,
  ],
  // Reports hub + the generic /crm/reports/:reportId detail. Detail's
  // basePattern (/crm/reports) prefix-matches so any report keeps Reports
  // active in the sidebar.
  [NAV_IDS.CRM_REPORTS]: [
    ROUTES.CRM_REPORTS,
    ROUTES.CRM_REPORT_DETAIL,
    // G13 — the builder lives under the same nav item, so composing a report
    // keeps Reports highlighted instead of dropping the sidebar selection.
    ROUTES.CRM_REPORT_BUILDER,
    ROUTES.CRM_REPORT_BUILDER_EDIT,
    // PLC W16 Inc-2 — the schedules page is part of Reports too.
    ROUTES.CRM_REPORT_SCHEDULES,
    // PLC W16 Inc-3 — and so is the distribution lists page.
    ROUTES.CRM_REPORT_DISTRIBUTION_LISTS,
    // PLC W16 Inc-4 — and so are report packages.
    ROUTES.CRM_REPORT_PACKAGES,
    ROUTES.CRM_REPORT_PACKAGE_DETAIL,
  ],
  [NAV_IDS.CRM_EVENTS]: [
    ROUTES.CRM_EVENTS,
    ROUTES.CRM_COMMUNITY_EVENTS,
    ROUTES.CRM_COMMUNITY_EVENT_DETAIL,
  ],
  [NAV_IDS.CRM_HEALTH]: [ROUTES.CRM_HEALTH],
  [NAV_IDS.CRM_SKYAGENT]: [ROUTES.CRM_SKYAGENT],
  [NAV_IDS.CRM_SKYBRAIN]: [ROUTES.CRM_SKYBRAIN],
  [NAV_IDS.CRM_AGENT_SKILLS]: [ROUTES.CRM_AGENT_SKILLS],
  [NAV_IDS.CRM_AGENT_DRAFTS]: [ROUTES.CRM_AGENT_DRAFTS],
  [NAV_IDS.CRM_MCP_CONNECTORS]: [ROUTES.CRM_MCP_CONNECTORS],
  [NAV_IDS.CRM_MESSENGER]: [ROUTES.CRM_MESSENGER],
  // Only the NEW address gets a pattern. The legacy /crm/global-setup path
  // redirects on render, so it never needs an active-state of its own.
  // `/crm/settings` is listed ALONGSIDE /crm/setup, and it is load-bearing.
  // Every Setup child lives at /crm/settings/* (~40 of them: data-export,
  // care-types, api-tokens, audit-retention …) and NONE of them had a pattern.
  // The prefix pass then fell through to the shortest thing that did match —
  // bare "/crm", which is mapped to Day Planner — so opening any Setup item
  // highlighted PLANNER in the sidebar while the page itself said "← Back to
  // Setup". The nav was pointing at a section the operator was not in.
  //
  // Longest-match makes "/crm/settings" (13) beat "/crm" (4), so the whole
  // family keeps Setup lit. Safe for access control: getRequiredNavId returns
  // null for every /crm/* path, so these patterns drive sidebar state only and
  // cannot gate a route.
  [NAV_IDS.CRM_SETUP]: [ROUTES.CRM_SETUP, "/crm/settings"],
  [NAV_IDS.CRM_LEAD_SOURCES]: [ROUTES.CRM_LEAD_SOURCES],
  [NAV_IDS.CRM_MESSAGE_TEMPLATES]: [ROUTES.CRM_MESSAGE_TEMPLATES],
  [NAV_IDS.CRM_COMMUNICATION_TEMPLATES]: [ROUTES.CRM_COMMUNICATION_TEMPLATES],
  [NAV_IDS.CRM_GOALS]: [ROUTES.CRM_GOALS],
  [NAV_IDS.CRM_CLINICAL_SYNC]: [ROUTES.CRM_CLINICAL_SYNC],
  [NAV_IDS.HELP_SUPPORT]: [ROUTES.HELPPLUSSUPPORT, ROUTES.QUERYANDISSUES],
};

/**
 * Returns the NavId that owns the given pathname, or null for unprotected routes.
 * Used by RouteGuard to enforce RBAC at the route level.
 * Single source of truth: if the nav item is visible in the sidebar, the route is accessible.
 */
export function getRequiredNavId(pathname: string): NavId | null {
  // /crm and /crm/* are gated by PackRouteGuard (senior_living pack), NOT
  // by RBAC nav-visibility. Return null so RouteGuard always lets it
  // through; the pack guard decides access. (getSelectedNavItem still
  // resolves /crm/* via ROUTE_PATTERNS for sidebar active-state.)
  //
  // Day-41+ post-ship fix: the `/crm` BARE landing must also pass through
  // unfiltered. Previously the check was `startsWith("/crm/")` which
  // missed bare `/crm` (no trailing slash). When a user in Advisor mode
  // clicked the CRM ModeToggle, the URL transit `/ → /crm → CrmLanding
  // Redirect → /crm/day-planner` was being short-circuited at `/crm`:
  // RouteGuard saw a CRM nav-id required AND visibleNavIds (Advisor-mode
  // sidebar) didn't contain it, so it bounced to `/` before CrmLanding
  // Redirect could fire. User reported as "dashboard remains when toggling
  // CRM from the dashboard".
  if (pathname === "/crm" || pathname.startsWith("/crm/")) {
    return null;
  }

  // First pass: exact matches
  for (const [navId, patterns] of Object.entries(ROUTE_PATTERNS)) {
    for (const pattern of patterns) {
      if (pathname === pattern) {
        return navId as NavId;
      }
    }
  }

  // Second pass: prefix matches — normalize :param segments, take longest match
  let bestMatch: { navId: NavId; patternLength: number } | null = null;
  for (const [navId, patterns] of Object.entries(ROUTE_PATTERNS)) {
    for (const pattern of patterns) {
      const basePattern = pattern.includes("/:") ? pattern.split("/:")[0] : pattern;
      if (pathname.startsWith(basePattern + "/") || pathname.startsWith(basePattern + "?")) {
        if (!bestMatch || basePattern.length > bestMatch.patternLength) {
          bestMatch = { navId: navId as NavId, patternLength: basePattern.length };
        }
      }
    }
  }

  return bestMatch?.navId ?? null;
}

/**
 * Sidebar-HIGHLIGHT-only overrides: route → the nav item to light up.
 *
 * Consulted by getSelectedNavItem ONLY, never by getRequiredNavId, so an entry
 * here changes what the sidebar shows as active and NOTHING about who may open
 * the route. /alert-banners is gated on ASA_LIST (it began life as an ASA
 * Content-tab page) but has its own Content Hub → Alert Banners menu item; via
 * ROUTE_PATTERNS alone it highlighted Sales Agent → Agent List.
 */
const HIGHLIGHT_ONLY_ROUTES: Record<string, NavId> = {
  [ROUTES.ALERT_BANNERS]: NAV_IDS.ALERT_BANNERS,
};

/** The highlight-only override for a path: trailing slashes are ignored and a
 *  deeper path-segment form ("/alert-banners/<instanceid>") counts too. A bare
 *  string prefix ("/alert-bannersX") does not. */
function getHighlightOnlyNavId(pathname: string): NavId | undefined {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  for (const [route, navId] of Object.entries(HIGHLIGHT_ONLY_ROUTES)) {
    if (path === route || path.startsWith(route + "/")) return navId;
  }
  return undefined;
}

export function getSelectedNavItem(
  pathname: string,
  queryString: string = "",
): {
  selectedId: string | undefined;
  selectedCategoryId: string | undefined;
} {
  const highlightOnly = getHighlightOnlyNavId(pathname);
  if (highlightOnly) {
    return { selectedId: highlightOnly, selectedCategoryId: getParentCategoryId(highlightOnly) };
  }

  // First pass: exact matches only — prevents /surveys/templates from being
  // claimed by the /surveys prefix match before survey-templates is checked.
  for (const [navId, patterns] of Object.entries(ROUTE_PATTERNS)) {
    for (const pattern of patterns) {
      const routeWithQuery = pattern + queryString;
      if (pathname === pattern || pathname === routeWithQuery) {
        return {
          selectedId: navId,
          selectedCategoryId: getParentCategoryId(navId as NavId),
        };
      }
    }
  }

  // Second pass: prefix matches — normalize :param segments, take the LONGEST
  // match (mirrors getRequiredNavId above). First-match was a bug: the bare
  // "/crm" pattern is mapped to Day Planner and is a prefix of every "/crm/*"
  // route, and it is declared before the specific CRM sections — so deep routes
  // like /crm/residents/:id and /crm/persons/:id matched "/crm" first and wrongly
  // highlighted Day Planner. Longest-match makes "/crm/residents" (len 14) beat
  // "/crm" (len 4); "/crm" still wins only for the bare landing (exact pass).
  let best: { navId: NavId; patternLength: number } | null = null;
  for (const [navId, patterns] of Object.entries(ROUTE_PATTERNS)) {
    for (const pattern of patterns) {
      const basePattern = pattern.includes("/:") ? pattern.split("/:")[0] : pattern;
      if (pathname.startsWith(basePattern + "/") || pathname.startsWith(basePattern + "?")) {
        if (!best || basePattern.length > best.patternLength) {
          best = { navId: navId as NavId, patternLength: basePattern.length };
        }
      }
    }
  }
  if (best) {
    return {
      selectedId: best.navId,
      selectedCategoryId: getParentCategoryId(best.navId),
    };
  }

  return {
    selectedId: NAV_IDS.DASHBOARD,
    selectedCategoryId: undefined,
  };
}

/**
 * The Settings group — shared PLATFORM surfaces that belong to neither half of
 * the product.
 *
 * Used for two things: resolving a route's active nav category, and deciding
 * that a route is mode-NEUTRAL. A CRM user opening Users or Roles from the Setup
 * hub is not leaving Sales for Marketing, and moving the persisted mode on their
 * behalf strands them in the other product (see ModeFollowsRoute).
 */
export const SETTINGS_GROUP_NAV_IDS: NavId[] = [
  NAV_IDS.GENERAL,
  // H3 Inc-2 — a Settings-group surface, so opening it never moves the operator
  // between Marketing and CRM view modes (isSettingsGroupRoute).
  NAV_IDS.CLOSE_REASONS,
  // PACE — the Stages settings page is a Settings-group surface too.
  NAV_IDS.STAGES,
  // R6 — the Advisor Setup hub is a Settings-group surface for the same reason.
  NAV_IDS.SETTINGS_SETUP,
  NAV_IDS.USERS,
  NAV_IDS.ROLES,
  NAV_IDS.LOCATIONS,
  NAV_IDS.OPERATORS,
  NAV_IDS.OWNERS,
  NAV_IDS.CHANNELS,
  NAV_IDS.CALL_MANAGEMENT,
  NAV_IDS.LOGS,
  NAV_IDS.PLATFORM,
  NAV_IDS.INSTANCES,
  NAV_IDS.TENANTS,
  NAV_IDS.INTEGRATIONS,
  NAV_IDS.CRM,
  NAV_IDS.NOTIFICATION_PREFERENCES,
  NAV_IDS.CONFIGURATIONS,
  // CRM-mode-only settings child; injected into the Settings group in
  // sidebar.tsx when operator_crm is active. Listed here so its
  // active-state resolves under the Settings category.
  //
  // Setup is the ONLY CRM child left. Lead Sources, Communication Templates,
  // Goals and Clinical Sync are no longer Settings children (the Setup hub is
  // their single door), so claiming them here would expand a Settings menu
  // that has nothing highlighted in it. Their NAV_TO_ROUTE_BASE /
  // ROUTE_PATTERNS rows stay — packNav reverse-resolves pack routes through
  // NAV_TO_ROUTE_BASE, and the routes themselves are unchanged.
  NAV_IDS.CRM_SETUP,
];

/**
 * Is this path a shared Settings-group surface, i.e. one that must NOT move the
 * view mode? Unmapped paths are not neutral — only the Settings group is, so a
 * genuine Marketing route still switches the shell to Marketing.
 */
export function isSettingsGroupRoute(pathname: string): boolean {
  const navId = getRequiredNavId(pathname);
  return navId !== null && SETTINGS_GROUP_NAV_IDS.includes(navId);
}

function getParentCategoryId(navId: NavId): string | undefined {
  const settingsSubmenu: NavId[] = SETTINGS_GROUP_NAV_IDS;

  const contentHubSubmenu: NavId[] = [
    NAV_IDS.VIDEOS,
    NAV_IDS.FLOOR_PLANS,
    NAV_IDS.TESTIMONIALS,
    NAV_IDS.FAQ,
    NAV_IDS.STAFF_PROFILES,
    NAV_IDS.ALERT_BANNERS,
  ];

  const salesAgentSubmenu: NavId[] = [
    NAV_IDS.ASA_LIST,
    NAV_IDS.MODAL_CONFIGS,
    NAV_IDS.WIDGET_PLACEMENTS,
    NAV_IDS.EMBED_SCRIPT,
    NAV_IDS.INQUIRY_TYPES,
    NAV_IDS.TOUR_AVAILABILITY,
  ];

  // The Referrers group (both list routes and both detail routes resolve to
  // one of these two children). SkyNavDrawer v2.1.1 auto-expands a parent
  // from `selectedId` alone, but the app contract stays correct here — the
  // sidebar already passes selectedCategoryId, and a future library version
  // may consume it.
  const crmReferrersSubmenu: NavId[] = [NAV_IDS.CRM_REFERRERS, NAV_IDS.CRM_ORGANIZATIONS];
  // Occupancy's children, so the Resolution Center keeps its parent expanded.
  const crmOccupancySubmenu: NavId[] = [NAV_IDS.CRM_OCCUPANCY, NAV_IDS.CRM_YARDI_RESOLUTION];

  if (settingsSubmenu.includes(navId)) {
    return NAV_IDS.SETTINGS;
  }

  if (contentHubSubmenu.includes(navId)) {
    return NAV_IDS.CONTENT_HUB;
  }

  if (salesAgentSubmenu.includes(navId)) {
    return NAV_IDS.SALES_AGENT;
  }

  if (crmReferrersSubmenu.includes(navId)) {
    return NAV_IDS.CRM_REFERRERS_HUB;
  }

  if (crmOccupancySubmenu.includes(navId)) {
    return NAV_IDS.CRM_OCCUPANCY_HUB;
  }

  return undefined;
}
